// extracted by mini-css-extract-plugin
export default {"acceptBtn":"DialogMessage_acceptBtn__z433K"};